import { useEffect, useState } from "react";
import {Select, DatePicker, Button, Input, Modal} from "antd"
import moment from 'moment';
import {comma} from "../../lib/util/numberUtil";
import {getRouletteInfo, getRouletteInfoFromAllServer, playRoulette} from "../../api/api";
import {addWaitingOrder} from "../../actions/posAction";
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

const EventResult = ({ joinAbleCount, eventIdx, closeEventDetail }) => {
    const [visible, setVisible] = useState(true);
    const [ticketCount, setTicketCount] = useState(0);
    const [rankList, setRankList] = useState([]);
    const [parsedRankList, setParsedRankList] = useState([]);

    const close = () => {
        setVisible(false);
        closeEventDetail();
    }


    useEffect(async () => {
        if (eventIdx === null || eventIdx === undefined || isNaN(eventIdx)) return;
        const res = await getRouletteInfo(eventIdx);
        const allServerRankList = await getRouletteInfoFromAllServer(eventIdx);
        if (
            res.result === 'SUCCESS'
            && allServerRankList?.data !== null
            && allServerRankList?.data !== undefined
            && allServerRankList?.data?.rankList !== null
            && allServerRankList?.data?.rankList !== undefined
            && Array.isArray(allServerRankList?.data?.rankList)
        ) {
            setRankList(allServerRankList?.data?.rankList);
        }
    }, []);

    useEffect(() => {
        let parsedRank = [];
        if (!Array.isArray(rankList)) {
            Modal.info({
                title: '조회실패',
                content: '이벤트 결과 조회에 실패했습니다.',
                ...modalStyle,
            })
            return;
        }
        for (let i = 1; i < 6; i++) {
            const list =  rankList.filter(rank => rank.rank === i);
            list.forEach(rank => parsedRank.push({
                rank: rank?.rank,
                prize: rank?.prize ? rank?.prize : 0,
                frName: rank?.name,
            }))
        }

        setParsedRankList(parsedRank);
    }, [rankList]);


    return (
        <div className="roullete mobileoff">
            {visible ?
                <div className="roullete-detail-content" >
                    <div className="roullete-detail-close" >
                        <img src={image.closeIcon} alt=""
                            onClick={close} />
                    </div>

                    <div className="roullete-result-img">
                        <div style={{display:'flex', flexDirection:'row'}}>
                            <div className="roullete-result-main-bg" />
                            <div className="roullete-result-table">
                                <div className={'roullete-result-table-title'}>9월 당첨 가맹점 발표</div>
                                <div className={'roullete-result-table-header'}>
                                    <div style={{flex: 1}}>등수</div>
                                    <div style={{flex: 2}}>지원금액(원)</div>
                                    <div style={{flex: 3}}>당첨 가맹점</div>
                                </div>
                                <div className={'roullete-result-table-body-wrapper'}>
                                    {
                                        parsedRankList.map(item => {
                                            return <div key={`${item.rank}/${item.frName}`} className={'roullete-result-table-row-wrapper'} style={{color:item.rank < 4 ? 'rgba(250, 220, 0, 1)' : 'white'}}>
                                                <div style={{flex: 1}}>{`${item.rank}등`}</div>
                                                <div style={{flex: 2}}>{comma(item.prize)}</div>
                                                <div style={{flex: 3}}>{item.frName}</div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                :
                <></>
            }
        </div>
    )

}

export default EventResult;
